import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../data/translations';
import { 
  HealthIcon, 
  NutritionIcon, 
  ProtectionIcon, 
  EducationIcon, 
  WashIcon, 
  EmergencyIcon, 
  FoodSecurityIcon, 
  CommunityIcon,
  CommunityEngagementIcon,
  MEALIcon,
  QualityIcon
} from './Icons';
import './Programs.css';

const Programs = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const programs = [
    { title: t.health, description: t.healthDesc, Icon: HealthIcon },
    { title: t.nutrition, description: t.nutritionDesc, Icon: NutritionIcon },
    { title: t.protection, description: t.protectionDesc, Icon: ProtectionIcon },
    { title: t.education, description: t.educationDesc, Icon: EducationIcon },
    { title: t.wash, description: t.washDesc, Icon: WashIcon },
    { title: t.emergencyRelief, description: t.emergencyReliefDesc, Icon: EmergencyIcon },
    { title: t.foodSecurity, description: t.foodSecurityDesc, Icon: FoodSecurityIcon },
    { title: t.communityDevelopment, description: t.communityDevelopmentDesc, Icon: CommunityIcon }
  ];

  const approaches = [
    { title: t.communityEngagement, description: t.communityEngagementDesc, Icon: CommunityEngagementIcon },
    { title: t.mealSystems, description: t.mealSystemsDesc, Icon: MEALIcon },
    { title: t.qualityDelivery, description: t.qualityDeliveryDesc, Icon: QualityIcon }
  ];

  return (
    <section id="programs" className="programs">
      <div className="container">
        <div className="section-header">
          <h2>{t.programmaticAreas}</h2>
          <p>{t.programsIntro}</p>
        </div>
        
        <div className="programs-grid">
          {programs.map((program, index) => (
            <div key={index} className="program-card">
              <div className="program-icon">
                <program.Icon />
              </div>
              <h3>{program.title}</h3>
              <p>{program.description}</p>
            </div>
          ))}
        </div>

        <div className="approach-section">
          <h3>{t.operationalApproach}</h3>
          <p>{t.approachText}</p>
          <div className="approach-grid">
            {approaches.map((approach, index) => (
              <div key={index} className="approach-item">
                <div className="approach-icon">
                  <approach.Icon />
                </div>
                <h4>{approach.title}</h4>
                <p>{approach.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Programs;
